import { styled } from 'stitches.config'
import { Text } from 'components/Text'
import { CtaButton } from 'components/CtaButton'

export const recipeColorVariant = {
  recipe: {
    default: {
      background: '$secondary-650',
      '&:hover, &:focus': {
        backgroundColor: '$secondary-650',
      },
    },
    chicken: {
      background: '$secondary-590',
      '&:hover, &:focus': {
        backgroundColor: '$secondary-590',
      },
    },
    beef: {
      background: '$quaternary-515',
      '&:hover, &:focus': {
        backgroundColor: '$quaternary-515',
      },
    },
    duck: {
      background: '$quaternary-555',
      '&:hover, &:focus': {
        backgroundColor: '$quaternary-555',
      },
    },
    turkey: {
      background: '$quaternary-90',
      '&:hover, &:focus': {
        backgroundColor: '$quaternary-90',
      },
    },
    lamb: {
      background: '$quaternary-530',
      '&:hover, &:focus': {
        backgroundColor: '$quaternary-530',
      },
    },
    venison: {
      background: '$quaternary-55',
      '&:hover, &:focus': {
        backgroundColor: '$quaternary-55',
      },
    },
  }
}

export const RequirementText = styled('div', {
  color: '$quaternary-200',
  fontSize: '$body',
  textAlign: 'center',
  width: '100%',
  padding: '$2',
  background: '$secondary-590',
  maxWidth: '800px',
  marginTop: '$6',
  marginBottom: '$2',

  '@bp3': {
    margin: 'auto',
    fontSize: '$bodyLarge'
  },

  variants: {
    ...recipeColorVariant
  }
})

export const Span = styled('span', {
  fontWeight: '$medium',
})

export const InfoWrapper = styled('div', {
  width: '100%',
  '& > div': {
    marginTop: 0,
  },
})

export const DesktopHeroWrapper = styled('div', {
  display: 'none',

  width: '50%',
  '& > div': {
    width: '100%',
  },

  '@bp3': {
    display: 'block',
  },
})

export const PricePerUnit = styled(Text, {
  textAlign: 'center',
  marginTop: '$3',
  marginBottom: '$2',
  '@bp3': {
    margin: 'auto',
  },
})

export const Spacer = styled('div', {
  height: '30px',
})

export const CtaButtonDisabled = styled(CtaButton, {
  color: '$accent-white',
  cursor: 'not-allowed',

  variants: {
    ...recipeColorVariant
  }
})